<template>
    <div class="form-field form-code" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <div class="editor-frame" v-bind:class="{'fullscreen': fullscreen}">
                    <div class="options">
                        <button @click="fullScreen()" class="close"><span class="icon icon-icon_expand" v-if="!fullscreen"></span><span class="icon icon-icon_close" v-if="fullscreen"></span></button>
                    </div>
                    <div class="editor">
                        <prism-editor v-model="internalValue" :language="language"></prism-editor>
                    </div>
                    <div class="preview">
                        <iframe frameborder="0" allowfullscreen="true" allowtransparency="true" :id="id"></iframe>
                    </div>
                </div>
                <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormCodeTextarea',
        props: ['value','label','name','placeholder','lang','required','language','callback'],
        data: function () {
            return {
                internalValue: '',
                langClass: '',
                fullscreen: false,
                id: null
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
            this.onChange = this.callback ? true : false;

            let r = Math.random().toString(36).substring(7);
            this.id = r;

            this.preview();
        },
        methods: {
            preview: function(){
                if( document.getElementById(this.id) && document.getElementById(this.id).contentWindow ){
                    var x = document.getElementById(this.id).contentWindow.document;
                    x.open();
                    x.write( this.internalValue );
                    x.close();

                    var elements = x.querySelectorAll("a");
                    for (var i= 0; i < elements.length; i++) {
                        elements[i].addEventListener("click", function(e){
                            e.preventDefault();
                            e.stopPropagation();
                            //alert(x.documentElement.innerHTML);
                            return false;
                        }, false);
                    }
                }
            },
            fullScreen: function(){
                this.fullscreen = !this.fullscreen;
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                this.preview();
            },
            'internalValue'(newVal, oldVal) {
                this.preview();
                this.$emit('input', this.internalValue);
                if( this.onChange ){
                    this.callback(this.internalValue)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Code.vue